import React from "react";
import { StandardDateField } from "./styled/standard";
import { DatePickerProps } from "@mui/x-date-pickers";

const BarekamDateInput = ({ errorMessage, ...props }: BarekamDateInputProps) => {
    // TODO: implement error handling
    return (
        <StandardDateField
            {...props}
            format={'DD-MM-YYYY'}
            label={
                <>
                    {props.label}
                    {props.required ? <span style={{ color: '#D42D4A' }}> *</span> : ''}
                </>
            }
            slotProps={{
                textField: {
                    error: !!errorMessage,
                    helperText: errorMessage,
                }
            }}
        />
    )

};

export default BarekamDateInput;

interface BarekamDateInputProps extends DatePickerProps<any> {
    required?: boolean
    errorMessage?: string;
}